import { Btn } from "@/components/ui/Btn/Btn";
import { MarketingFooter } from "@/components/marketing/MarketingFooter";
import { MarketingNav } from "@/components/marketing/MarketingNav";
import styles from "./NotFound.module.css";

export function NotFound() {
  return (
    <>
      <MarketingNav />
      <main className={styles.main}>
        <div className={styles.inner}>
          <p className={styles.eyebrow}>404</p>
          <h1 className={styles.title}>That page doesn&apos;t exist.</h1>
          <p className={styles.body}>
            The page you&apos;re looking for hasn&apos;t been built yet, was
            moved, or never existed. Head back to the homepage or check
            pricing.
          </p>
          <div className={styles.actions}>
            <Btn href="/" variant="primary" size="md">
              Back to home
            </Btn>
            <Btn href="/pricing" variant="secondary" size="md">
              See pricing
            </Btn>
          </div>
        </div>
      </main>
      <MarketingFooter />
    </>
  );
}
